module.exports = __webpack_public_path__ + "static/img/head.cfd4b538.gif";